// Global Date and Time Formatter Utility

export const DATE_FORMATS = {
  'YYYY-MM-DD': 'YYYY-MM-DD',
  'DD/MM/YYYY': 'DD/MM/YYYY',
  'MM/DD/YYYY': 'MM/DD/YYYY',
};

export const TIME_FORMATS = {
  '12H': '12H', // 12-hour format with AM/PM (e.g. 09:30:15 PM)
  '24H': '24H', // 24-hour format (e.g. 21:30:15)
};

export const getStoredDateFormat = () => {
  return localStorage.getItem('system_date_format') || 'YYYY-MM-DD';
};

export const getStoredTimeFormat = () => {
  return localStorage.getItem('system_time_format') || '24H';
};

export const setStoredDateFormat = (format) => {
  localStorage.setItem('system_date_format', format);
  window.dispatchEvent(new Event('system_date_time_format_changed'));
};

export const setStoredTimeFormat = (format) => {
  localStorage.setItem('system_time_format', format);
  window.dispatchEvent(new Event('system_date_time_format_changed'));
};

// Helper function to convert digits dynamically
export const convertDigits = (str) => {
  if (str === null || str === undefined) return str;
  const s = String(str);
  const format = localStorage.getItem('system_number_format') || 'english';
  if (format === 'arabic') {
    // Replace Western digits with Eastern Arabic digits
    return s.replace(/[0-9]/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
  } else {
    // Replace Eastern Arabic digits with Western digits
    return s.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
  }
};

// Helper function to format a Date object
export const formatSystemDate = (dateObj, format = getStoredDateFormat()) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    return dateObj;
  }
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');

  let result = '';
  switch (format) {
    case 'DD/MM/YYYY':
      result = `${day}/${month}/${year}`;
      break;
    case 'MM/DD/YYYY':
      result = `${month}/${day}/${year}`;
      break;
    case 'YYYY-MM-DD':
    default:
      result = `${year}-${month}-${day}`;
  }
  return convertDigits(result);
};

export const formatSystemTime = (dateObj, format = getStoredTimeFormat()) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    return dateObj;
  }
  let hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');

  let result = '';
  if (format === '12H') {
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const strHours = String(hours).padStart(2, '0');
    result = `${strHours}:${minutes}:${seconds} ${ampm}`;
  } else {
    const strHours = String(hours).padStart(2, '0');
    result = `${strHours}:${minutes}:${seconds}`;
  }
  return convertDigits(result);
};

// Prototype overrides removed to prevent breaking third-party libraries (e.g. calendars)
export const initGlobalDateTimeFormatter = () => {
  // Initialization of global formatter (empty as we now rely on utility functions explicitly instead of prototypes)
};
